import { defineMessages } from 'react-intl';

export default defineMessages({
    policylandingCategory: {
        id: 'twia.views.policy-landing.Category',
        defaultMessage: 'Category',
    },
    policylandingPolicyLine: {
        id: 'twia.views.policy-landing.Policy Line',
        defaultMessage: 'Product',
    },
});
